module.exports = __webpack_public_path__ + "img/ct.7eeeaee3.png";